import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            description: {
                paddingBottom: theme.spacing(3),
            },
            header: {
                paddingBottom: theme.spacing(1),
                marginTop: theme.spacing(2),
            },
            tableHeader: {
                fontSize: '0.75rem',
                backgroundColor: 'inherit',
                paddingBottom: '0',
                borderTop: '0',
                paddingTop: '0',
            },
            tableHeaderRow: {
                height: '25px',
                verticalAlign: 'top',
            },
            tableContainer: {
                overflowX: 'auto',
            },
            createServiceAccountRow: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: theme.spacing(2),
            },
            // Bordered, unfilled button rather than a solid PrimaryButton.
            createServiceAccountButton: {
                padding: '0.3125rem 0.9375rem',
                font: 'inherit',
                fontWeight: 'bold',
                color: theme.palette.text.primary,
                backgroundColor: 'transparent',
                border: `1px solid ${theme.palette.text.primary}`,
                borderRadius: '0.125rem',
                textAlign: 'center',
                cursor: 'pointer',
                '&:disabled': {
                    cursor: 'not-allowed',
                    opacity: 0.5,
                },
            },
        }),
    {
        name: 'SnowflakeAccountSettings-',
    },
);
